class CarouselProgressBar extends HTMLElement {
  /** @type {HTMLElement | null} */
  #scroller = null;
  /** @type {HTMLElement | null} */
  #thumb = null;
  /** @type {HTMLElement | null} */
  #track = null;
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    this.#thumb = this.querySelector('.resource-list__progress-thumb');
    this.#track = this.querySelector('.resource-list__progress-track');
    if (!this.#thumb || !this.#track) return;

    requestAnimationFrame(() => this.#bind());
  }

  disconnectedCallback() {
    if (this.#scroller) {
      this.#scroller.removeEventListener('scroll', this.#update);
    }
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    this.#scroller = null;
  }

  #bind() {
    const carousel = this.closest('.resource-list__carousel');
    if (!carousel) return;

    const scroller = carousel.querySelector('slideshow-slides');
    if (!(scroller instanceof HTMLElement)) return;

    this.#scroller = scroller;
    scroller.addEventListener('scroll', this.#update, { passive: true });
    this.#resizeObserver = new ResizeObserver(this.#update);
    this.#resizeObserver.observe(scroller);
    this.#update();
  }

  #update = () => {
    const scroller = this.#scroller;
    const thumb = this.#thumb;
    const track = this.#track;
    if (!scroller || !thumb || !track) return;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    if (maxScroll <= 0) {
      this.style.display = 'none';
      return;
    }
    this.style.display = '';

    const thumbW = Math.max(25, (scroller.clientWidth / scroller.scrollWidth) * 100);
    const progress = scroller.scrollLeft / maxScroll;
    const maxTranslate = (100 / thumbW) * 100 - 100;
    thumb.style.width = `${thumbW}%`;
    thumb.style.transform = `translateX(${progress * maxTranslate}%)`;
  };
}

if (!customElements.get('carousel-progress-bar')) {
  customElements.define('carousel-progress-bar', CarouselProgressBar);
}
